import { Tag, TagProps } from 'antd';

import { RecruitmentProcessCollection } from '../../types';

interface RecruitmentProcessStatusProps extends TagProps {
  status: RecruitmentProcessCollection['status'];
}

const RecruitmentProcessStatus = ({ status, ...props }: RecruitmentProcessStatusProps) => {
  return (
    <>
      {status === 'ACTIVE' && (
        <Tag color="success" data-testid="recruitment-process-status-active" {...props}>
          Ativo
        </Tag>
      )}
      {status === 'INACTIVE' && (
        <Tag color="error" data-testid="recruitment-process-status-inactive" {...props}>
          Reprovado
        </Tag>
      )}
      {status === 'GIVEN_UP' && (
        <Tag color="warning" data-testid="recruitment-process-status-givenup" {...props}>
          Desistente
        </Tag>
      )}
    </>
  );
};

export default RecruitmentProcessStatus;
